































































import { Component, Prop, Vue } from "vue-property-decorator";
import { GameConfigType, GameType, PlayerType, PlayersType } from "@/types";
import PlayerList from "@/components/game/PlayerList.vue";
import PlayerTag from "@/components/game/PlayerTag.vue";
import Scoreboard from "@/components/game/Scoreboard.vue";
import GalleryList from "@/components/game/GalleryList.vue";
import TopicsList from "@/components/game/TopicsList.vue";

@Component({ components: { PlayerList, PlayerTag, Scoreboard, GalleryList, TopicsList } })
export default class Voting extends Vue {
  @Prop({ required: true }) config!: GameConfigType;
  @Prop({ required: true }) game!: GameType;
  @Prop({ required: true }) isOwner!: boolean;
  @Prop({ required: true }) player!: PlayerType;
  @Prop({ required: true }) players!: PlayersType;

  get agentIds() {
    return Object.keys(this.game.roles).filter((r) => this.game.roles[r] === "agent");
  }
  get aliveIds() {
    return Object.keys(this.players).filter((r) => !this.game.deaths[r]);
  }
  get imposterIds() {
    return Object.keys(this.game.roles).filter((r) => this.game.roles[r] === "imposter");
  }
  get pointsText() {
    const points = this.game.roles[this.player.id] === "imposter" ? 2 : 1;
    return this.game.deaths[this.player.id]
      ? "0 Points"
      : `${points} Point${points === 2 ? "s" : ""}`;
  }
  get unvotedIds() {
    const votes = this.game.votes[this.player.id];
    if (!votes?.value) return Object.keys(this.players);
    return Object.keys(this.players).filter((id) => !votes.value.includes(id));
  }
  get topics() {
    return this.game.topics.slice(0, 2);
  }
  get topicsImposter() {
    return this.game.topics.slice(2);
  }

  handleEndGame() {
    return this.$root.$data.store.gameUpdate({ state: "lobby" });
  }
  handleNewRound() {
    return this.$root.$data.store.roundStart(this.game);
  }
}
